// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"header-module--header-logo--fryqo","headerLogoResponsive":"header-module--header-logo-responsive--3oGbE"};